"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styled = exports.useTheme = exports.DefaultThemeProvider = void 0;
var react_1 = __importDefault(require("react"));
var react_2 = require("@emotion/react");
Object.defineProperty(exports, "useTheme", { enumerable: true, get: function () { return react_2.useTheme; } });
var styled_1 = __importDefault(require("@emotion/styled"));
var react_helmet_async_1 = require("react-helmet-async");
var theme_1 = __importDefault(require("./styles/theme"));
var react_i18next_1 = require("react-i18next");
var i18n_1 = __importDefault(require("./utils/i18n"));
var Box_1 = __importDefault(require("./Box"));
// override type of emotion Theme
require("./types/emotion");
function DefaultThemeProvider(_a) {
    var children = _a.children, zIndices = _a.zIndices, customizedTheme = _a.customizedTheme;
    if (zIndices !== undefined) {
        theme_1.default.zIndices = __assign(__assign({}, theme_1.default.zIndices), zIndices);
    }
    var mergedTheme = theme_1.default;
    if (customizedTheme !== undefined) {
        mergedTheme = __assign(__assign({}, theme_1.default), customizedTheme);
    }
    return (react_1.default.createElement(react_helmet_async_1.HelmetProvider, null,
        react_1.default.createElement(react_i18next_1.I18nextProvider, { i18n: i18n_1.default },
            react_1.default.createElement(react_2.ThemeProvider, { theme: mergedTheme }, children))));
}
exports.DefaultThemeProvider = DefaultThemeProvider;
var styledBox = (0, styled_1.default)(Box_1.default);
var styled = styled_1.default;
exports.styled = styled;
styled.Box = styledBox;
